export const SET_HELPERS = "SET_HELPERS";
export const SET_FORM = "SET_STEP"
export const SET_DATE = "SET_DATE"
export const DELETE_SERVICE = "DELETE_SERVICE"
export const SET_IDRESERVA = "SET_IDRESERVA"
export const RESET_STORE = "RESET_STORE"
export const RESET_SERVICES = "RESET_SERVICES"
